import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const LineDevice916: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>{'.line9-16_svg__cls-3{fill:#9e9e9e}'}</style>
    </defs>
    <g id="line9-16_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="line9-16_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path
          d="M138 39.65v-18a14.29 14.29 0 00-14.25-14.32h-14.1v1.92a7.58 7.58 0 01-7.57 7.59h-59a7.58 7.58 0 01-7.58-7.59V7.33H20.56A14.3 14.3 0 006.28 21.64v18z"
          fill="#263147"
        />
        <path
          d="M6.28 134.41v144.83a14.31 14.31 0 0014.31 14.31h103.1A14.31 14.31 0 00138 279.24V134.41z"
          fill="#fff"
        />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <circle className="line9-16_svg__cls-3" cx={16.47} cy={29.75} r={4.62} />
        <circle className="line9-16_svg__cls-3" cx={127.11} cy={29.75} r={4.62} />
        <path transform="rotate(90 72.41 157.95)" fill="#1ca64d" d="M-46.63 91.97h238.08v131.95H-46.63z" />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();
export default LineDevice916;
